import React, { useCallback, useMemo } from 'react';
import Particles from '@tsparticles/react';
import { loadSlim } from '@tsparticles/slim';

const ParticleBackground = () => {
  const particlesInit = useCallback(async (engine) => {
    await loadSlim(engine);
  }, []);

  const options = useMemo(() => ({
    fullScreen: {
      enable: true,
      zIndex: 0
    },
    background: {
      color: {
        value: "#000000"
      }
    },
    fpsLimit: 60,
    interactivity: {
      events: {
        onHover: {
          enable: true,
          mode: "grab"
        },
        resize: {
          enable: true
        }
      },
      modes: {
        grab: {
          distance: 150,
          links: {
            opacity: 0.3,
            color: "#00F0FF"
          }
        }
      }
    },
    particles: {
      color: {
        value: ["#00F0FF", "#00F0FF", "#00F0FF", "#FF003C"]
      },
      links: {
        color: "#00F0FF",
        distance: 150,
        enable: true,
        opacity: 0.15,
        width: 1
      },
      move: {
        direction: "none",
        enable: true,
        outModes: {
          default: "bounce"
        },
        random: true,
        speed: 0.5,
        straight: false
      },
      number: {
        density: {
          enable: true,
          area: 1000
        },
        value: 100
      },
      opacity: {
        value: {
          min: 0.3,
          max: 0.8
        },
        animation: {
          enable: true,
          speed: 0.5,
          sync: false
        }
      },
      shape: {
        type: "circle"
      },
      size: {
        value: {
          min: 1,
          max: 3
        }
      }
    },
    detectRetina: true
  }), []);

  return (
    <Particles
      id="tsparticles"
      init={particlesInit}
      options={options}
    />
  );
};

export default ParticleBackground;
